"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const getNumberFromUnknown_1 = __importDefault(require("../../shared/getNumberFromUnknown"));
const buildCallableResizeImage = (args) => async ({ functionId, entryVars: { path, width, height, }, callbacks, executeProcesses, }) => {
    try {
        if (!(0, valueIsString_1.default)(path)) {
            executeProcesses(functionId, callbacks.onError, 'Image path required');
            return;
        }
        const maxWidth = (0, getNumberFromUnknown_1.default)(width || 256);
        const maxHeight = (0, getNumberFromUnknown_1.default)(height || 256);
        if (maxWidth > 5000) {
            executeProcesses(functionId, callbacks.onError, 'Width must be less than 5000 px');
            return;
        }
        if (maxHeight > 5000) {
            executeProcesses(functionId, callbacks.onError, 'Height must be less than 5000 px');
            return;
        }
        const newPhoto = await args.resizeImage({
            path,
            width: maxWidth,
            height: maxHeight,
        });
        executeProcesses(functionId, callbacks.onResizer, newPhoto);
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        executeProcesses(functionId, callbacks.onError, `${errorMessage}`);
    }
};
exports.default = buildCallableResizeImage;
